import React, { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
    LazyLoadImage,
    LazyLoadComponent,
} from "react-lazy-load-image-component";
import ToggleModal from "./ToggleModal";

import { apiUrl } from "../../../services/constants";
import MainContext from "../../../context/Main";
import PacifierPicture from "./PacifierPicture";

export default function Collections({ collections, category }) {
    const navigate = useNavigate();
    const {
        selectProductName,
        selectPdfUrl,
        setSelectProductName,
        setSelectPdfUrl,
    } = useContext(MainContext);

    const handleModalClick = (name, pdfUrl) => {
        setSelectProductName(name);
        setSelectPdfUrl(pdfUrl);
    };

    const handleImage = (collection) => {
        window.localStorage.setItem('category', category);
        window.localStorage.setItem('product_name', collection.attributes.name);
        navigate('/product-detail');
    }

    return (
        <ToggleModal name={selectProductName} url={selectPdfUrl}>
            <div className="row row-cols-2 row-cols-lg-5 g-2 g-lg-3">
                {collections.map((collection) => {
                    return (
                        <div
                            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 themed-grid-col text-center product-image-click"
                            key={collection.id}
                        >
                            <a onClick={() => handleImage(collection)}>
                                {collection.attributes.image.data?.attributes
                                    ?.url ? (
                                    <LazyLoadImage
                                        src={
                                            apiUrl +
                                            collection.attributes.image.data
                                                ?.attributes?.url
                                        }
                                        width={150}
                                        height="auto"
                                        effect="opacity"
                                    />
                                ) : (
                                    <PacifierPicture />
                                )}
                            </a>
                            <p>{collection.attributes.name}</p>
                            <a
                                href={
                                    apiUrl +
                                    collection.attributes.spec_pdf.data
                                        ?.attributes?.url
                                }
                                target="_blank"
                            >
                                View Spec Sheet
                            </a>

                            <button
                                onClick={() =>
                                    handleModalClick(
                                        collection.attributes.name,
                                        apiUrl +
                                        collection.attributes.spec_pdf.data
                                            ?.attributes?.url
                                    )
                                }
                                type="button"
                                className="btn btn-outline-dark border-0 btn-email-spec border-dark"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                            >
                                Email Spec
                            </button>
                        </div>
                    );
                })}
            </div>
        </ToggleModal>
    );
}
